import React from 'react';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  return (
    <div className="payment-success-container">
      <h1 className="payment-success-title">Payment Successful</h1>

      <p className="payment-success-message">
        Your payment was successful. You’ve secured your spot in the game!
      </p>

      <div className="payment-success-section">
        <h2>What’s Next</h2>
        <ul>
          <li>Check your email for a confirmation receipt.</li>
          <li>You can view your booked games in the app under "My Games".</li>
          <li>Arrive at the field 10 minutes early and be ready to play.</li>
        </ul>
      </div>

      <div className="payment-success-section">
        <h2>Need Help?</h2>
        <p>
          If you didn’t receive confirmation or have questions, contact us at{' '}
          <a href="mailto:support@goalflex.net">support@goalflex.net</a>.
        </p>
      </div>

      <div className="payment-success-section">
        <h2>Return</h2>
        <a href="/games" className="payment-success-back-button">Back to Games</a>
      </div>
    </div>
  );
};

export default PaymentSuccess;